<template>
  <ValidationObserver ref="userLoginForm">
    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div class="container">
       <div class="row justify-content-center">
  
            <div class="form-wraapper-inner">
              <h1>Passwort zurücksetzen</h1>
              <p>Bitte geben Sie Ihr neues Passwort ein.</p>

              <div v-if="formErr" role="alert" class="alert alert-danger">
                <div class="alert-text">{{ formErr }}</div>
              </div>
              <ValidationProvider
                name="Password"
                vid="password"
                :rules="
                  userType !== '' && userType == 'producer'
                    ? 'required|passwordProducerInput'
                    : 'required|passwordInput'
                "
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'New password is required.',
                }"
              >
                <div class="password-input-div">
                  <v-text-field
                    :type="show === true ? 'text' : 'password'"
                    autocomplete="new-password"
                    v-model="form.password"
                    :error-messages="errors[0]"
                    label="Neues Passwort"
                    @input="passwordCheck"
                    outlined
                  ></v-text-field>
                  <i
                    class="fas fa-eye show-icon"
                    v-if="show"
                    @click="show = !show"
                  ></i>
                  <i
                    class="fas fa-eye-slash show-icon"
                    v-else
                    @click="show = !show"
                  ></i>
                </div>
                <div v-if="form.password" class="row password-strength mt-3">
                  <div class="col-md-10 p-0">
                    <v-progress-linear
                      :value="progressValue"
                      :color="progressColor"
                    ></v-progress-linear>
                  </div>
                  <div class="col-md-2 pr-0 text-right">
                    <span>{{ passwordStrength }}</span>
                  </div>
                </div>
                <span class="note-text text-secondary"
                  >Das Passwort muss mindestens
                  {{
                    userType !== "" && userType == "producer" ? "8" : "6"
                  }}
                  Zeichen enthalten, darunter je mindestens ein Sonderzeichen,
                  eine Zahl, sowie einen Kleinbuchstaben und einen
                  Großbuchstaben.</span
                >
              </ValidationProvider>

              <ValidationProvider
                name="Password confirmation"
                rules="required|confirmed:password"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Please confirm new password.',
                }"
              >
                <div class="password-input-div">
                  <v-text-field
                    :type="show2 === true ? 'text' : 'password'"
                    autocomplete="new-password"
                    v-model="form.rePassword"
                    :error-messages="errors[0]"
                    label="Neues Passwort bestätigen"
                    outlined
                  ></v-text-field>
                  <i
                    class="fas fa-eye show-icon"
                    v-if="show2"
                    @click="show2 = !show2"
                  ></i>
                  <i
                    class="fas fa-eye-slash show-icon"
                    v-else
                    @click="show2 = !show2"
                  ></i>
                </div>
              </ValidationProvider>

              <v-btn
                type="submit"
                ref="kt_form_submit_btn"
                class="submit-btn-fill-color"
                :disabled="isDisabled"
              >
                {{ btnText }}
              </v-btn>
              <div class="signin">
                <p><router-link to="/">Zurück zum Login</router-link>.</p>
              </div>
            </div> 

            <div class="col-md-12 go-to-home-page mt-8 text-center"> 
                <a href="https://gustoreich.at">
                <v-btn depressed class="outline-button"><b-icon icon="arrow-left" class="mr-3" ></b-icon>Zurück zur Startseite</v-btn>
                </a>
            </div>

        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { FRONTEND_LOGIN } from "@/core/services/store/auth.module";
import frontendAPI from "@/api/frontend";
import axios from "axios";
import { extend } from "vee-validate";

extend("passwordInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+,.\\\/;':"-]).{6,}$/;
    var validPassword = regx.test(value);
    if (validPassword) {
      return true;
    } else {
      false;
    }
  },
});

extend("passwordProducerInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+,.\\\/;':"-]).{8,}$/;
    var validPassword = regx.test(value);
    if (validPassword) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "ResetPassword",
  created() {
    this.getUserType();
  },
  data() {
    return {
      btnText: "Abschicken",
      btnDisable: false,
      userType: "",
      show: false,
      show2: false,
      isPoor: false,
      isGood: false,
      isStrong: false,
      passwordStrength: "Poor",
      contains_lovercase: false,
      contains_number: false,
      contains_uppercase: false,
      containSpecialChar: false,
      progressValue: 0,
      progressColor: "error",
      form: {
        password: "",
        rePassword: "",
      },
      formErr: "",
    };
  },
  methods: {
    getUserType() {
      frontendAPI.getUserType(this.$route.query.email).then((response) => {
        if (response.status === "success") {
          this.userType = response.data;
        }
      });
    },
    passwordCheck(val) {
      this.contains_lovercase = /[a-z]/.test(this.form.password);
      this.contains_number = /\d/.test(this.form.password);
      this.contains_uppercase = /[A-Z]/.test(this.form.password);
      this.containSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
        this.form.password
      );

      if (this.form.password.length > 0 && this.form.password.length <= 6) {
        this.isPoor = true;
        this.passwordStrength = "Poor";
        this.progressValue = 33;
        this.progressColor = "error";
      } else {
        this.isPoor = false;
      }
      if (this.form.password.length > 6) {
        this.isGood = true;
        this.passwordStrength = "Good";
        this.progressValue = 66;
        this.progressColor = "yellow darken-2";
      } else {
        this.isGood = false;
      }
      if (
        this.form.password.length > 6 &&
        this.contains_lovercase &&
        this.contains_number &&
        this.contains_uppercase &&
        this.containSpecialChar
      ) {
        this.isStrong = true;
        this.passwordStrength = "Strong";
        this.progressValue = 100;
        this.progressColor = "green";
      } else {
        this.isStrong = false;
      }
    },
    onSubmit() {
      this.formErr = null;
      this.$refs.userLoginForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.btnText = "Wird abgeschickt...";
          let data = {
            email: this.$route.query.email,
            password: this.form.password,
          };
          axios
            .post("update-password", data)
            .then((response) => {
              var responseJson = response.data;
              if (responseJson.status == "success") {
                this.btnDisable = false;
                this.btnText = "Abschicken";
                this.$router.push({ name: "login" });
              } else {
                this.btnDisable = false;
                this.btnText = "Abschicken";
                this.formErr = responseJson.message;
              }
            })
            .catch((err) => {
              this.btnDisable = false;
              this.btnText = "Abschicken";
              this.formErr = err;
            });
        }
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
.password-input-div {
  position: relative;
}
.show-icon {
  position: absolute;
  top: 22px;
  right: 20px;
  cursor: pointer;
}

.strendth-div {
  border: 1px solid lightgrey;
  height: 7px;
  margin: 2px;
  border-radius: 10px;
}
.red {
  background-color: red;
}

.orange {
  background-color: orange;
}

.green {
  background-color: green;
}
</style>